import {
    ChangeEventHandler,
    ClipboardEventHandler, FocusEventHandler,
    KeyboardEventHandler,
    MouseEventHandler, ReactNode, useEffect, useRef
} from 'react';
import { IFormControl } from '../interfaces';

interface IFormTextAreaField {
    id: string,
    label: string,
    control: IFormControl,
    maxLength?: number,
    focus?: boolean,
    rows?:number,
    cols?:number,

    // event handlers
    onBlur?: FocusEventHandler,
    onChange?: ChangeEventHandler,
    onClick?: MouseEventHandler,
    onKeyUp?: KeyboardEventHandler,
    onPaste?: ClipboardEventHandler,

    // html content
    comment?: ReactNode,

    // styles
    rootClasses?: string,
    textBoxClasses?: string,
}

/**
 * Text field.
 */
const FormTextAreaField = (props: IFormTextAreaField) => {

    // can be used for focus on page load
    const controlRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {

        if(!props.focus) return;

        // on page load -> focus on the field
        if(!controlRef || !controlRef.current) return;
        controlRef.current.focus();
    }, [props.focus]);




    return (
        <div className={ props.rootClasses ? props.rootClasses : 'mb-6'}>
            <div className={`w-form-field ${!props.control.isValid ? 'w-form-error' : ''} `}>

                <textarea
                    id={ props.id }
                    className={`w-form-tb ${ props.textBoxClasses || '' } ${ (props.control.value !== null && props.control.value.length > 0) ? 'not-empty': '' } `}
                    maxLength={ props.maxLength }
                    value={ props.control.value }
                    onBlur={ props.onBlur }
                    onChange={ props.onChange }
                    onClick={  props.onClick }
                    onKeyUp={ props.onKeyUp }
                    onPaste={ props.onPaste }
                    ref={ controlRef }
                    rows={props.rows? props.rows : 4}
                    cols={props.cols? props.cols : 4}

                />

                <label htmlFor={ props.id } className="w-form-label top-0 mt-2">{ props.label }</label>

            </div>

            { props.control.isValid && props.comment }

            {
                !props.control.isValid &&
                <div className="text-red text-sm"
                     aria-label={ `${ props.label } error: ${  props.control.error }` }
                     role="alert">
                    { props.control.error }
                </div>
            }
        </div>
    )
};

export default FormTextAreaField;